import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ReviewEntriesState } from './../state/review-entries.state';

// Feature Selector
export const selectReviewEntriesState = createFeatureSelector<ReviewEntriesState>('reviewEntries');

// Groups Selectors
export const selectGroups = createSelector(
  selectReviewEntriesState,
  (state) => state.groups
);

export const selectGroupsLoading = createSelector(
  selectReviewEntriesState,
  (state) => state.loading
);

export const selectGroupsError = createSelector(
  selectReviewEntriesState,
  (state) => state.error
);

export const selectGroupsSupervisorNumber = createSelector(
  selectReviewEntriesState,
  (state) => state.groupsSupervisorNumber
);

export const areGroupsLoaded = createSelector(
  selectGroups,
  (groups) => groups.length > 0 // Check if groups are already loaded
);

// Departments Selectors
export const selectDepartments = createSelector(
  selectReviewEntriesState,
  (state) => state.departments
);

export const areDepartmentsLoaded = createSelector(
  selectDepartments,
  (departments) => departments.length > 0 // Check if departments are already loaded
);

// Pending Records Selectors
export const selectPendingRecords = createSelector(
  selectReviewEntriesState,
  (state) => state.pendingRecords
);

export const arePendingRecordsLoaded = createSelector(
  selectPendingRecords,
  (pendingRecords) => pendingRecords.length > 0 // Check if pending records are already loaded
);

// Calendar Counts Selectors
export const selectCounts = createSelector(
  selectReviewEntriesState,
  (state) => state.counts
);

export const areCountsLoaded = createSelector(
  selectCounts,
  (counts) => counts.length > 0 // Check if counts are already loaded
);

// Calendar Info
export const selectCalendarInfo = createSelector(
  selectReviewEntriesState,
  (state) => state.calendarInfo
);

export const selectCalendarInfoKey = createSelector(
  selectReviewEntriesState,
  (state) => state.calendarInfoKey
);

export const isCalendarInfoLoaded = createSelector(
  selectCalendarInfo,
  (calendarInfo) => calendarInfo !== null // Check if calendarInfo is already loaded
);

export const selectCalendarInfoLoading = createSelector(
  selectReviewEntriesState,
  (state) => state.loading
);

export const selectCalendarInfoError = createSelector(
  selectReviewEntriesState,
  (state) => state.error
);

// Page Supervisor Head Emp Details
export const selectSupervisorHeadEmpDetails = createSelector(
  selectReviewEntriesState,
  (state) => state.supervisorHeadEmpDetails
);

export const areSupervisorHeadDetailsLoaded = createSelector(
  selectSupervisorHeadEmpDetails,
  (details) => details && details.length > 0
);

// Page Supervisor Head Details
export const selectSupervisorHeadDetails = createSelector(
  selectReviewEntriesState,
  (state) => state.headDetails
);

export const selectLastLoadedParams = createSelector(
  selectReviewEntriesState,
  (state) => state.lastLoadedParams
);

export const isSupervisorHeadDetailsLoaded = createSelector(
  selectSupervisorHeadDetails,
  selectLastLoadedParams,
  (details: any, params: any, props: any) => {
    return (
      details.length > 0 &&
      params &&
      JSON.stringify(params) === JSON.stringify(props)
    );
  }
);